module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Dinner-41d7790b9db37155777182364484e1ba.svg";